import { mapState, mapMutations, mapGetters } from 'vuex'
import locale from '@components/base/locale'
import search from '@components/ui-components/search/component'

export default {
  data() {
    return {
      menuIndex: -1,
      menuName: null,
      openClasses: -1,
      openCategory: -1,
    }
  },
  components: {
    locale,
    'search-cmp': search,
  },
  computed: {
    ...mapState('mobile', ['isMobileMenuVisible', 'isMobile']),
    ...mapGetters('lk', ['isAuth', 'linkLogout']),
  },
  watch: {
    isMobileMenuVisible: function() {
      if (!this.isMobileMenuVisible) {
        this.menuIndex = -1
        this.menuName = null
        this.openClasses = -1
      }
    },
  },
  methods: {
    ...mapGetters('mobile', ['isVisibleSubmenu']),
    ...mapMutations('mobile', ['setActiveSubmenuIndex']),

    openMenuDes(index) {
      this.menuIndex = index
      this.openClasses = -1
    },
    toPage(link) {
      this.menuIndex = -1
      this.$router.push(link)
    },
    clickMenuItem(index, isServices, isDecisions) {
      if (isServices) {
        this.menuName = 'services'
      } else if (isDecisions) {
        this.menuName = 'decisions'
      } else {
        this.setActiveSubmenuIndex(index)
      }
    },
    openMenuCategory(index) {
      this.openCategory = index
    },
    clickMenuDecisions(keySubitem, key2) {
      this.menuIndex = keySubitem
      this.openClasses = key2
    },
  },
}



// WEBPACK FOOTER //
// ./src/templates/components/mobile-menu/component.js